/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resume_WebInputs */

const en_resume_web = /** @type {(inputs: Resume_WebInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Web`)
};

const ar_resume_web = /** @type {(inputs: Resume_WebInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الويب`)
};

const bn_resume_web = /** @type {(inputs: Resume_WebInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ওয়েব`)
};

const de_resume_web = /** @type {(inputs: Resume_WebInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Web`)
};

const es_resume_web = /** @type {(inputs: Resume_WebInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Web`)
};

const fr_resume_web = /** @type {(inputs: Resume_WebInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Web`)
};

const pt_resume_web = /** @type {(inputs: Resume_WebInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Web`)
};

const zh_resume_web = /** @type {(inputs: Resume_WebInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`网页`)
};

const tr_resume_web = /** @type {(inputs: Resume_WebInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Web`)
};

const ru_resume_web = /** @type {(inputs: Resume_WebInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Интернет`)
};

const pl_resume_web = /** @type {(inputs: Resume_WebInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sieć`)
};

/**
* | output |
* | --- |
* | "Web" |
*
* @param {Resume_WebInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const resume_web = /** @type {((inputs?: Resume_WebInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resume_WebInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_resume_web(inputs)
	if (locale === "bn") return bn_resume_web(inputs)
	if (locale === "de") return de_resume_web(inputs)
	if (locale === "es") return es_resume_web(inputs)
	if (locale === "fr") return fr_resume_web(inputs)
	if (locale === "pt") return pt_resume_web(inputs)
	if (locale === "zh") return zh_resume_web(inputs)
	if (locale === "tr") return tr_resume_web(inputs)
	if (locale === "ru") return ru_resume_web(inputs)
	if (locale === "pl") return pl_resume_web(inputs)
	return en_resume_web(inputs)
});